import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { MessageService } from 'primeng/api';
import { loginRequest, msalConfig } from './auth-config';

import {
    IPublicClientApplication,
    PublicClientApplication,
    InteractionType,
    LogLevel,
    BrowserCacheLocation,
  } from '@azure/msal-browser';
import {
    MSAL_INSTANCE,
    MsalGuardConfiguration,
    MSAL_GUARD_CONFIG,
    MsalService,
    MsalBroadcastService,
    MsalGuard,
    MsalRedirectComponent,
    MsalInterceptor,
    MsalModule,
    MsalInterceptorConfiguration,
    MSAL_INTERCEPTOR_CONFIG,
    ProtectedResourceScopes,
  } from '@azure/msal-angular';
import { environment } from './environments/environment';
import { registerLocaleData } from '@angular/common';
import localeIT from '@angular/common/locales/it';  
import { GEO_API_BASE_URL } from '@pipegrep/appshellc_19';
import { GeoInterceptor } from './app/services/geo.interceptor';

registerLocaleData(localeIT);
export function loggerCallback(logLevel: LogLevel, message: string) {
    console.log(message);
  }
  
  export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication(msalConfig);
  }
  
  export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string | ProtectedResourceScopes>>()
  
    environment.serverlist.forEach(itm => {
      var arr = [];
      if (itm.scopes !== null) {
        arr.push({httpMethod: 'GET',scopes: [...itm.scopes.read]})
        arr.push({httpMethod: 'POST',scopes: [...itm.scopes.write]})
        arr.push({httpMethod: 'PUT',scopes: [...itm.scopes.write]})
        arr.push({httpMethod: 'DELETE',scopes: [...itm.scopes.write]})
        arr.push({httpMethod: 'PATCH',scopes: [...itm.scopes.write]})
      }else {
        arr.push({httpMethod: 'GET',scopes: null})
        arr.push({httpMethod: 'POST',scopes: null})
        arr.push({httpMethod: 'PUT',scopes: null})
        arr.push({httpMethod: 'DELETE',scopes: null})
        arr.push({httpMethod: 'PATCH',scopes: null})
      }
      
      protectedResourceMap.set(itm.endpoint, arr);
    });
    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap,
    };
  }
  
  export function MSALGuardConfigFactoryOld(): MsalGuardConfiguration {
    return {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [...environment.loginRequest.scopes],
      },
      loginFailedRoute: '/login-failed',
    };
  }
  export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: loginRequest
    };
  }
  

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch()),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        importProvidersFrom(MessageService),
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GeoInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },

    { provide: GEO_API_BASE_URL, useValue: environment.GEO_API_BASE_URL },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    ]
};
